module.exports = __webpack_public_path__ + "img/hand-point-up.3aed8938.svg";